import { useQueryHelper } from '@anytag/shared-hooks';
import { Tabs } from '@anytag/shared-atoms';
import { useUserRoles } from '@anytag/auth';

export const YoutubeCMSTabs = () => {
  const { t, search } = useQueryHelper();
  const { isAdminStaff } = useUserRoles();

  return isAdminStaff ? (
    <Tabs
      className="px-4"
      options={[
        { end: true, label: t('Estimated Revenue'), to: '/youtube-cms/revenue', search },
        {
          end: true,
          label: t('Confirmed Revenue'),
          to: '/youtube-cms/revenue/confirmed',
          search
        }
      ]}
    />
  ) : null;
};
